import script from "./InvoiceTermsEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceTermsEditor.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceTermsEditor.vue?vue&type=style&index=0&id=c0cf679e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0cf679e"]])

export default __exports__